import { put, call } from 'redux-saga/effects';

import { resendTwoFactorAuthCode } from '@api/auth';
import { toastError, toastSuccess } from '@store/notifications';

/**
 * Handles OTP resend for 2FA Setup
 * @param {Object} payload
 */
export const handleResendTwoFactorAuthCodeRequest = function* ({ payload = {} }) {
  try {
    yield call(resendTwoFactorAuthCode, payload.token);

    yield put(
      toastSuccess({
        message: {
          defaultMessage: 'OTP resent.',
          id: 'components.verify-otp-panel.resend.response.success',
        },
      })
    );
  } catch (error) {
    yield put(
      toastError({
        message: {
          defaultMessage: 'Resend OTP request failed.',
          id: 'components.verify-otp-panel.resend.response.failure',
        },
      })
    );
  }
};
